@if (loader) {
<app-loader></app-loader>
}
<p-toast></p-toast>

<div>
  <form [formGroup]="linkedFiledForm">
    <div class="flex align-items-start">
      <div *ngIf="!isEdit">
        <p-button label="Save" class="p-button-outlined ml-2" icon="pi pi-save" size="small"
          (click)="saveLinkedFiles(linkedFiledForm.value, isEdit)">
        </p-button>
      </div>
      <div *ngIf="isEdit">
        <p-button label="Update" class="p-button-outlined ml-2" icon="pi pi-save" size="small"
          (click)="Update(linkedFiledForm.value)">
        </p-button>
      </div>
      <div>
        <p-button label="Cancel" class="p-button-outlined ml-2" icon="pi pi-times" severity="danger" size="small"
          (click)="cancel(linkedFiledForm.value)">
        </p-button>
      </div>
    </div>

    <div class="grid padd">

      <div class="col-5">
        <div class="field text-left">
          <label>Document Type</label>
          <p-dropdown formControlName="type" [options]="documentTypeOptions" placeholder="Select Document Type"
            styleClass="w-full" [disabled]="isEdit">
          </p-dropdown>
        </div>
      </div>

      <div class="col-5">
        <div class="field text-left" *ngIf="!isEdit">
          <label>Linked File</label>
          <input type="file" class="w-full p-inputtext-sm" (change)="onFileChange($event)" />
        </div>

        <div class="field text-left" *ngIf="isEdit">
          <label>&nbsp;</label>
          <p-button icon="pi pi-eye" (click)="viewDocument(fileContent)" size="small"
            class="p-button-rounded p-button-outlined">
          </p-button>
        </div>
      </div>

      <div class="col-5">
        <div class="field text-left">
          <label>Linked By</label>
          <input pInputText class="w-full p-inputtext-sm" formControlName="linkedBy" />
        </div>
      </div>

      <div class="col-5">
        <div class="field text-left">
          <label>Date</label>
          <p-calendar formControlName="date" dateFormat="dd/mm/yy" styleClass="w-full" [showIcon]="true"
            [appendTo]="'body'">
          </p-calendar>
        </div>
      </div>

      <div class="col-5">
        <div class="field text-left">
          <label>Description</label>
          <textarea rows="1" pInputTextarea class="w-full p-inputtext-sm" formControlName="description">
      </textarea>
        </div>
      </div>

      <div class="col-5">
        <div class="field text-left mt-4">
          <p-checkbox [binary]="true" formControlName="sendMail" inputId="sendMail">
          </p-checkbox>
          <label for="sendMail" class="ml-2">Send via Email</label>
        </div>
      </div>
    </div>
  </form>
</div>
